import React, {useEffect, useState} from 'react';
import '../CSS/PopupModal.css';
import popup from '../resource/popup_modal.png';

const PopupModal = ({ onClose }) => {

    return (
        <div className="popup-backdrop">
            <div className="popup-content">
                <div className="popup-image-wrapper">
                    <img src={popup} alt="이벤트 안내" className="popup-image" />
                    <div className="popup-text-overlay">
                        <p>
                            📅 <strong>예약 방법</strong><br/>
                            예약은 전화예약을 통해 가능합니다.<br/>
                            <strong>010-2180-7979 / 010-7447-9222</strong><br/>
                            예약 전 객실 정보와 요금표를 꼭 확인해주세요.<br/><br/>

                            💳 <strong>입금 안내</strong><br/>
                            예약 후 2시간 이내 입금해주셔야 예약이 확정됩니다.<br/>
                            입금 후 입금자 성함을 문자로 꼭 보내주셔야 예약이 완료됩니다.<br/>
                            성함을 보내주시지 않으면 예약확인이 어렵습니다.<br/>
                            중복예약이 될 수 있으니 꼭 확인 부탁드립니다.<br/>
                            입금자명이 예약자명과 다를 경우 꼭 미리 알려주세요.<br/><br/>
                            <strong>농협은행 717096-52-18-6664 윤정아</strong>
                        </p>
                    </div>
                </div>

                <div className="popup-actions">
                    <span onClick={() => {
                        const expiry = new Date();
                        expiry.setDate(expiry.getDate() + 1);
                        localStorage.setItem("hidePopupUntil", expiry.toISOString());
                        onClose();
                    }}>
                        하루동안 보지 않기
                    </span>
                    <span onClick={onClose}>닫기</span>
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
